import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { AiSetProps } from './AiSetFakedoorModal';

export const renderAiSetFakedoorModal = (data: AiSetProps) => {
    openPopupHelper({
        popupName: popupNames.AI_SET_FAKEDOOR_MODAL,
        data,
        onClose: data.onClose,
    });
};

export const renderAiSetOkModal = () => {
    openPopupHelper({
        popupName: popupNames.AI_SET_OK_MODAL,
    });
};
